"use client"

import { getFixedT } from "@/languages/i18n"
import { Form, Input, InputRef } from "antd"
import { RefObject } from "react"

interface IcoFieldProps {
    icoInputRef: RefObject<InputRef | null>
    fetchingIco: boolean
    onFetchIcoData: () => void
    errorMessage?: string | null
    onClearError?: () => void
    locale?: string
}

export const IcoField: React.FC<IcoFieldProps> = ({
    icoInputRef,
    fetchingIco,
    onFetchIcoData,
    errorMessage,
    onClearError,
    locale,
}) => {
    const t = getFixedT(locale)
    return (
        <Form.Item
            label={
                <span className="text-base leading-[24.8px] text-[#212529] font-medium">
                    {t("IČO")} <span className="text-red-500">*</span>
                </span>
            }
        >
            <div className="flex">
                {/* noStyle Form.Item bọc trực tiếp Input để antd bind được value/onChange (div cha không bind được) */}
                <Form.Item name="ico" noStyle rules={[{ required: true, message: t("Cannot be empty") }]}>
                    <Input
                        ref={icoInputRef}
                        className="flex-1 rounded-tl-[4px] rounded-bl-[4px] rounded-r-none focus:ring-2 focus:ring-[#00A651]"
                        onChange={() => {
                            if (errorMessage && onClearError) {
                                onClearError();
                            }
                        }}
                    />
                </Form.Item>

                <button
                    type="button"
                    onClick={onFetchIcoData}
                    disabled={fetchingIco}
                    className="px-3 h-12 bg-[#00A651] text-white 
             rounded-tr-[4px] rounded-br-[4px] rounded-l-none
             hover:bg-[#2f9e44] transition-colors whitespace-nowrap 
             disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {fetchingIco ? t("Loading...") : t("Get data")}
                </button>
            </div>
            <p className={`text-sm mt-[5px] ${errorMessage ? "text-red-500" : "text-gray-500"}`}>
                {errorMessage || t("Please enter your IČO and click Get data")}
            </p>
        </Form.Item>
    )
}

